export default require('./TabTitle').default
